import {IBDStore} from "../../../../store/store";
import {setLatestEntry} from "../../redux/latest_entry_slice";
import {fetchLastAvailableEntry} from "./fetch_last_available_date";

export const setLatestEntryAction = async (store: IBDStore) => {
    const latestEntry = await fetchLastAvailableEntry();
    store.dispatch(setLatestEntry(latestEntry));
};
